import vtxDomReady from './common/helpers';
vtxDomReady(() => {
  const FWP = window.FWP;
  if (FWP) {
    FWP.hooks.addAction('facetwp/loaded', function () {
      var theText = FWP.facets.search_keyword;
      if (!theText) {
        theText = '';
      }
      var spanText = document.querySelector('#fwp_search_word');
      if (spanText) {
        spanText.innerHTML = theText;
      }
    });
  }
});
